import { render, staticRenderFns } from "./NotificationInfo.vue?vue&type=template&id=02905ae2&"
import script from "./NotificationInfo.vue?vue&type=script&lang=js&"
export * from "./NotificationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports